import React from 'react';
import { makeObservable, observable, action, computed } from 'mobx';
import DocumentHistoryRequests from 'Utils/Requests/DocumentHistoryRequests';
import FiltersStore from 'Stores/DocumentHistory/FiltersStore';
import AppStore from "Stores/AppStore";
import { ShowAlert } from "Utils/CommonFunctions";
import LoadingIndicator from "Components/Common/LoadingIndicator";
import TasksStore from 'Stores/tasksStore';

class DocumentHistoryStore {
    recordsLoading;
    pageToSet;

    constructor() {
        makeObservable(this, {
            recordsLoading: observable,
        });

        this.ClearStore();
    }

    ClearStore = action(() => {
        this.recordsLoading = false;
        this.pageToSet = 1;
    });

    SetTableStore(store) {
        this.tableStore = store;
    }

    GetData = action((pageToSet) => {
        if (pageToSet)
            this.pageToSet = pageToSet;
        if (!this.pageToSet)
            this.pageToSet = 1;

        this.recordsLoading = true;
        let elementsPerPage = this.tableStore.paginationInfo.elementsPerPage;
        let start = (this.pageToSet - 1) * elementsPerPage;

        let filters = {
            ...FiltersStore.filters,
            start: start,
            length: elementsPerPage
        };

        DocumentHistoryRequests.GetData(filters).then(action((values) => {
            if (values.error) {
                ShowAlert('error', "Ошибка поиска");
                return;
            }

            if (!this.tableStore.HandlePagination(this.SetPageData, values.recordsFiltered, this.pageToSet, page => this.GetData(page)))
                return;

            this.tableStore.data = values.data;

            this.recordsLoading = false;
        }));
    });

    SetPageData(pageToSet) {
        window.history.pushState(null, "Выгрузка документов", `${window.SmrLocation}/documentHistory?page=${pageToSet}`);

        AppStore.SetLastPageInfo({
            pageTitle: 'documentHistory',
            params: {
                page: `${pageToSet}`
            }
        });
    }

    ExportTaskRun(doc, withFiles) {
        let isMeeting = AppStore.isMeeting;

        DocumentHistoryRequests.ExportTaskRun(doc.id, withFiles)
            .then(action(values => {
                if (values.error)
                    return;

                TasksStore.SetCurrentDownloadingTask(values.value, {
                    canBeClosed: false,
                    header: `Архивация ${isMeeting ? "совещания" : "документа"}`,
                    getChildren: () => (<div>
                        <div className="document-history-progress-modal-description">
                            Выполняется формирование архива {isMeeting ? "совещания" : "документа"}. Пожалуйста, подождите...
                        </div>
                        <LoadingIndicator loaded={TasksStore.currentDownloadingTask?.progress}
                            total={100}
                            runner={false} />
                    </div>),
                    getButtons: () =>
                        [
                            {
                                content: 'Отменить',
                                closer: true,
                                onClick: () => TasksStore.CancelCurrentDownloadingTask(),
                                className: TasksStore.currentDownloadingTask?.isCanceled ? "disabled" : null
                            }
                        ]
                });
            }));
    }
}

export default new DocumentHistoryStore();